import { createFileRoute, redirect } from "@tanstack/react-router";
import { getPreviewRedirect } from "@/features/preview/navigation";
import { useQuery } from "@tanstack/react-query";
import { buildHref } from "@softmax/web-addresses";
import { publicNavigationOptions } from "@softmax/web-features/site/queries";
import { SiteNav } from "@softmax/web-features/site";
import { SweepLink } from "@softmax/design-system";

export const Route = createFileRoute("/_site/preview/$")({
  beforeLoad: async ({ location, abortController }) => {
    const href = await getPreviewRedirect({
      href: location.href,
      signal: abortController.signal,
    });
    throw redirect({ href, statusCode: 307 });
  },
  notFoundComponent: PreviewNotFound,
});

function PreviewNotFound() {
  const navigation = useQuery(publicNavigationOptions());
  return (
    <>
      <SiteNav browseItems={navigation.data} shellPill />
      <main id="main" data-shell-page className="w-full bg-[#fffdf4]">
        <div className="mx-auto flex min-h-[60vh] max-w-[1200px] flex-col items-start justify-center gap-[14px] px-[32px] py-[64px] md:px-[48px] lg:px-[64px]">
          <p className="font-plex-sans text-[14px] leading-[normal] tracking-[0.28px] text-[#707070]">
            404
          </p>
          <h1 className="home-font-title font-plex-mono text-[28px] leading-[1.11] font-semibold tracking-[-1px] text-[#161616] md:text-[32px]">
            No coworld at this address
          </h1>
          <p className="home-font-body max-w-[560px] font-plex-sans text-[18px] leading-[1.6] text-[#5e5e5e]">
            Coworlds come and go — the browse page lists every one you can play
            or watch right now.
          </p>
          <div className="flex flex-wrap items-center gap-[12px] pt-[6px]">
            <SweepLink href={buildHref({ name: "browse" })}>
              <span className="font-plex-sans text-[13px] leading-[normal] whitespace-nowrap text-[#161616]">
                Browse all coworlds
              </span>
              <img
                alt=""
                src="/home/chevron-right-small.svg"
                className="block h-[9px] w-[5px] shrink-0"
              />
            </SweepLink>
            <a
              href={buildHref({ name: "home" })}
              className="font-plex-sans text-[13px] leading-[normal] text-[#707070] underline decoration-[rgba(22,22,22,0.3)] underline-offset-[3px] hover:text-[#161616]"
            >
              Back to softmax.com
            </a>
          </div>
        </div>
      </main>
    </>
  );
}
